import { useContext } from 'react'

import { TimezoneContext } from './components/TimezoneProvider/TimezoneProvider'

export const useTimezone = (): string | undefined => {
  return useContext(TimezoneContext)
}
